<div class="field">
  <div class="control">
    <button
      type="{{ type }}"
      class="button is-link is-rounded"
      (click)="clickButton.emit()"
      [class.is-loading]="isLoading"
      [class.is-pulled-left]="isLeft"
      [class.is-pulled-right]="!isLeft"
      [class.is-fullwidth]="isFullWidth"
      [class.is-inverted]="isInverted"
      [class.is-outlined]="isOutlined"
      [class.is-white]="isWhite"
      [class.is-danger]="isDanger"
      [class.is-success]="isSuccess"
      [class.is-narrow]="isNarrow"
      [disabled]="disabled"
    >
      <p class="is-size-6 weight-medium">{{ inputText }}</p>
    </button>
  </div>
</div>
